import { render } from "./StudiosPage.vue?vue&type=template&id=7bab0061"
import script from "./StudiosPage.vue?vue&type=script&lang=js"
export * from "./StudiosPage.vue?vue&type=script&lang=js"

import "./StudiosPage.vue?vue&type=style&index=0&id=7bab0061&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__